import { render, staticRenderFns } from "./KeyboardShortcutsContainer.vue?vue&type=template&id=34ad8e6b&scoped=true&"
import script from "./KeyboardShortcutsContainer.vue?vue&type=script&lang=js&"
export * from "./KeyboardShortcutsContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34ad8e6b",
  null
  
)

export default component.exports